import { useAtomValue } from 'jotai';
import React, { useState } from 'react';
import styled from 'styled-components';

import { DefaultHeader } from '../../components/DefaultHeader';
import { LoadingContainer } from '../../components/LoadingContainer';
import { useConfig } from '../../hooks/use-config';
import { useGetReferral } from '../../hooks/use-get-referral';
import { userAtom } from '../../jotai-atoms/user.atom';
import { Background } from '../../stories/Background';
import { ReferralConfirmation } from './components/ReferralConfirmation';

export const SharePage: React.FC = () => {
  const { config } = useConfig();
  const user = useAtomValue(userAtom);

  const [agreed, setAgreed] = useState(false);
  const { isError, isFetching, referral } = useGetReferral();

  const handleSubmitAgreement = () => {
    setAgreed(true);
  };

  const url = new URL(`${config.assetsBucket}/assets/extole.html`);
  url.searchParams.append('source', 'oejr_lms');
  if (referral?.partnerUserId) {
    url.searchParams.append('partner_user_id', referral.partnerUserId);
  }
  if (referral?.firstName) {
    url.searchParams.append('first_name', referral.firstName);
  }
  if (referral?.lastName) {
    url.searchParams.append('last_name', referral.lastName);
  }
  if (referral?.labels) {
    url.searchParams.append('labels', referral.labels);
  }
  if (referral?.email) {
    url.searchParams.append('email', referral.email);
  }
  if (user?.lang) {
    url.searchParams.append('locale', user.lang);
  }

  return (
    <div className="oejr-page-activity">
      <DefaultHeader />
      {agreed ? (
          <iframe id="extole" src={url.href} title="Referral"/>
      ) : isFetching ? (
        <LoadingContainer />
      ) : (
        <StyledBackground>
          <Container>
            <ReferralConfirmation onSubmit={handleSubmitAgreement} isError={isError} />
          </Container>
        </StyledBackground>
      )}
    </div>
  );
};

const StyledBackground = styled(Background)`
  display: block;
  text-align: center;
  overflow: scroll;
  padding: 24px 0;
`;

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
